"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var ConfirmDialog_1 = __importDefault(require("../../../../../../packages/ui-shared-lite/ConfirmDialog"));
var MoreOptions_1 = __importDefault(require("../../../../../../packages/ui-shared-lite/MoreOptions"));
var Close_1 = __importDefault(require("../icons/Close"));
var Delete_1 = __importDefault(require("../icons/Delete"));
var Download_1 = __importDefault(require("../icons/Download"));
var Information_1 = __importDefault(require("../icons/Information"));
var List_1 = __importDefault(require("../icons/List"));
var Reload_1 = __importDefault(require("../icons/Reload"));
var Avatar_1 = __importDefault(require("./common/Avatar"));
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.btnEls = {};
        _this.state = {
            currentFocusIdx: undefined,
            showingOption: false
        };
        _this.onBlur = function () {
            _this.setCurrentFocusIdx(undefined);
        };
        _this.setCurrentFocusIdx = function (currentFocusIdx) {
            _this.setState({ currentFocusIdx: currentFocusIdx });
        };
        _this.changeButtonFocus = function (step) {
            var idx = _this.state.currentFocusIdx !== null ? _this.state.currentFocusIdx + step : 0;
            if (idx < 0) {
                _this.onBlur();
                _this.props.focusPrevious();
            }
            for (idx; idx < Object.keys(_this.btnEls).length; idx++) {
                if (_this.btnEls[idx]) {
                    _this.btnEls[idx].focus();
                    _this.setCurrentFocusIdx(idx);
                    break;
                }
            }
            if (idx === Object.keys(_this.btnEls).length) {
                _this.onBlur();
                _this.props.focusNext();
            }
        };
        _this.renderTitle = function () {
            var title = _this.props.isConversationsDisplayed
                ? _this.props.intl.formatMessage({ id: 'header.conversations' })
                : _this.props.botName;
            return (react_1.default.createElement("div", { className: 'bpw-header-title' },
                react_1.default.createElement("div", { className: 'bpw-header-name' },
                    title,
                    _this.props.hasUnreadMessages && react_1.default.createElement("span", { className: 'bpw-header-unread' }, _this.props.unreadCount)),
                _this.props.hasBotInfoDescription && (react_1.default.createElement("div", { className: 'bpw-header-subtitle' }, _this.props.botConvoDescription))));
        };
        _this.handleDeleteConversation = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, ConfirmDialog_1.default)(this.props.intl.formatMessage({
                            id: 'header.deleteConversation'
                        }), {
                            acceptLabel: this.props.intl.formatMessage({
                                id: 'header.deleteConversationYes'
                            }),
                            declineLabel: this.props.intl.formatMessage({
                                id: 'header.deleteConversationNo'
                            })
                        })];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.deleteConversation()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleKeyDown = function (action, e) {
            if (!_this.props.enableArrowNavigation) {
                return;
            }
            if (e.key === 'ArrowUp') {
                _this.props.focusPrevious();
            }
            else if (e.key === 'ArrowDown') {
                _this.props.focusNext();
            }
            else if (e.key === 'ArrowLeft') {
                _this.changeButtonFocus(-1);
            }
            else if (e.key === 'ArrowRight') {
                _this.changeButtonFocus(1);
            }
            else if (e.key === 'Enter') {
                e.preventDefault();
                action();
            }
        };
        _this.setShowingOption = function (val) {
            _this.setState({ showingOption: val });
        };
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        var _this = this;
        (0, mobx_1.observe)(this.props.focusedArea, function (focus) {
            focus.newValue === 'header' && _this.changeButtonFocus(1);
        });
    };
    Header.prototype.renderDeleteConversationButton = function () {
        var _this = this;
        return (react_1.default.createElement("button", { type: "button", tabIndex: -1, id: "btn-delete-conversation", "aria-label": this.props.intl.formatMessage({
                id: 'header.deleteConversationButton',
                defaultMessage: 'Delete conversation'
            }), title: this.props.intl.formatMessage({
                id: 'header.deleteConversationButton',
                defaultMessage: 'Delete conversation'
            }), ref: function (el) { return (_this.btnEls[0] = el); }, className: 'bpw-header-icon bpw-header-icon-delete', onClick: this.handleDeleteConversation, onKeyDown: this.handleKeyDown.bind(this, this.handleDeleteConversation), onBlur: this.onBlur },
            react_1.default.createElement(Delete_1.default, null)));
    };
    Header.prototype.renderResetButton = function () {
        var _this = this;
        return (react_1.default.createElement("button", { type: "button", tabIndex: -1, id: "btn-reset", "aria-label": this.props.intl.formatMessage({
                id: 'header.resetConversation',
                defaultMessage: 'Reset conversation'
            }), title: this.props.intl.formatMessage({
                id: 'header.resetConversation',
                defaultMessage: 'Reset conversation'
            }), ref: function (el) { return (_this.btnEls[1] = el); }, className: 'bpw-header-icon bpw-header-icon-reset', onClick: this.props.resetSession, onKeyDown: this.handleKeyDown.bind(this, this.props.resetSession), onBlur: this.onBlur },
            react_1.default.createElement(Reload_1.default, null)));
    };
    Header.prototype.renderDownloadButton = function () {
        var _this = this;
        return (react_1.default.createElement("button", { type: "button", tabIndex: -1, id: "btn-download", "aria-label": this.props.intl.formatMessage({
                id: 'header.downloadConversation',
                defaultMessage: 'Download conversation'
            }), title: this.props.intl.formatMessage({
                id: 'header.downloadConversation',
                defaultMessage: 'Download conversation'
            }), ref: function (el) { return (_this.btnEls[2] = el); }, className: 'bpw-header-icon bpw-header-icon-download', onClick: this.props.downloadConversation, onKeyDown: this.handleKeyDown.bind(this, this.props.downloadConversation), onBlur: this.onBlur },
            react_1.default.createElement(Download_1.default, null)));
    };
    Header.prototype.renderConvoButton = function () {
        var _this = this;
        return (react_1.default.createElement("button", { type: "button", tabIndex: -1, id: "btn-conversations", "aria-label": this.props.intl.formatMessage({
                id: 'header.conversations',
                defaultMessage: 'Conversations'
            }), title: this.props.intl.formatMessage({
                id: 'header.conversations',
                defaultMessage: 'Conversations'
            }), ref: function (el) { return (_this.btnEls[3] = el); }, className: 'bpw-header-icon bpw-header-icon-convo', onClick: this.props.toggleConversations, onKeyDown: this.handleKeyDown.bind(this, this.props.toggleConversations), onBlur: this.onBlur },
            react_1.default.createElement(List_1.default, null)));
    };
    Header.prototype.renderBotInfoButton = function () {
        var _this = this;
        return (react_1.default.createElement("button", { type: "button", tabIndex: -1, id: "btn-botinfo", "aria-label": this.props.intl.formatMessage({
                id: 'header.botInfo',
                defaultMessage: 'Bot information'
            }), title: this.props.intl.formatMessage({
                id: 'header.botInfo',
                defaultMessage: 'Bot information'
            }), ref: function (el) { return (_this.btnEls[4] = el); }, className: 'bpw-header-icon bpw-header-icon-botinfo', onClick: this.props.toggleBotInfo, onKeyDown: this.handleKeyDown.bind(this, this.props.toggleBotInfo), onBlur: this.onBlur },
            react_1.default.createElement(Information_1.default, null)));
    };
    Header.prototype.renderCloseButton = function () {
        var _this = this;
        return (react_1.default.createElement("button", { type: "button", id: "btn-close", "aria-label": this.props.intl.formatMessage({
                id: 'header.hideChatWindow',
                defaultMessage: 'Hide the chat window'
            }), title: this.props.intl.formatMessage({
                id: 'header.hideChatWindow',
                defaultMessage: 'Hide the chat window'
            }), ref: function (el) { return (_this.btnEls[5] = el); }, className: 'bpw-header-icon bpw-header-icon-close', onClick: this.props.hideChat, onKeyDown: this.handleKeyDown.bind(this, this.props.hideChat), onBlur: this.onBlur },
            react_1.default.createElement(Close_1.default, null)));
    };
    Header.prototype.renderCustomButtons = function () {
        var _this = this;
        return this.props.customButtons.map(function (btn) {
            var Icon = btn.icon;
            return (react_1.default.createElement("button", { type: "button", key: btn.id, id: "btn-".concat(btn.id), tabIndex: -1, className: 'bpw-header-icon', onClick: btn.onClick.bind(_this, btn.id, _this), "aria-label": btn.label || '', title: btn.label || '' }, typeof Icon === 'function' ? react_1.default.createElement(Icon, null) : Icon));
        });
    };
    Header.prototype.render = function () {
        var optionsItems = [];
        if (this.props.showDownloadButton) {
            optionsItems.push({
                label: 'Download Conversation',
                action: this.props.downloadConversation
            });
        }
        if (this.props.showConversationsButton) {
            optionsItems.push({
                label: 'Toggle List View',
                action: this.props.toggleConversations
            });
        }
        if (this.props.showBotInfoButton) {
            optionsItems.push({
                label: 'Toggle Bot Info',
                action: this.props.toggleBotInfo
            });
        }
        if (this.props.showDeleteConversationButton) {
            optionsItems.push({
                label: 'Delete conversation',
                action: this.props.deleteConversation
            });
        }
        if (this.props.isEmulator) {
            return (react_1.default.createElement("div", { className: "bpw-emulator-header" },
                react_1.default.createElement("span", { className: "bpw-emulator-header-tab" }, "Emulator"),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { className: "bpw-emulator-buttons" }, this.props.showResetButton && this.renderResetButton()),
                    react_1.default.createElement(MoreOptions_1.default, { show: this.state.showingOption, onToggle: this.setShowingOption, items: optionsItems }))));
        }
        return (react_1.default.createElement("div", { className: 'bpw-header-container' },
            react_1.default.createElement("div", { className: 'bpw-header-title-flexbox' },
                react_1.default.createElement("div", { className: 'bpw-header-title-container' },
                    react_1.default.createElement(Avatar_1.default, { name: this.props.botName, avatarUrl: this.props.botAvatarUrl, height: 40, width: 40 }),
                    this.renderTitle())),
            !!this.props.customButtons.length && this.renderCustomButtons(),
            this.props.showDeleteConversationButton && this.renderDeleteConversationButton(),
            this.props.showResetButton && this.renderResetButton(),
            this.props.showDownloadButton && this.renderDownloadButton(),
            this.props.showConversationsButton && this.renderConvoButton(),
            this.props.showBotInfoButton && this.renderBotInfoButton(),
            this.props.showCloseButton && this.renderCloseButton()));
    };
    return Header;
}(react_1.default.Component));
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        intl: store.intl,
        isConversationsDisplayed: store.view.isConversationsDisplayed,
        showDeleteConversationButton: store.view.showDeleteConversationButton,
        showDownloadButton: store.view.showDownloadButton,
        showBotInfoButton: store.view.showBotInfoButton,
        showConversationsButton: store.view.showConversationsButton,
        showResetButton: store.view.showResetButton,
        showCloseButton: store.view.showCloseButton,
        hasUnreadMessages: store.view.hasUnreadMessages,
        unreadCount: store.view.unreadCount,
        focusPrevious: store.view.focusPrevious,
        focusNext: store.view.focusNext,
        focusedArea: store.view.focusedArea,
        hideChat: store.view.hideChat,
        toggleConversations: store.view.toggleConversations,
        toggleBotInfo: store.view.toggleBotInfo,
        customButtons: store.view.customButtons,
        deleteConversation: store.deleteConversation,
        resetSession: store.resetSession,
        downloadConversation: store.downloadConversation,
        botName: store.botName,
        botAvatarUrl: store.botAvatarUrl,
        hasBotInfoDescription: store.hasBotInfoDescription,
        isEmulator: store.isEmulator,
        botConvoDescription: store.config.botConvoDescription,
        enableArrowNavigation: store.config.enableArrowNavigation
    });
})((0, mobx_react_1.observer)(Header));
